import { useEffect, useState } from 'react'

/**
 * Viewport check for the floating booking bar. The WP plugin swaps the
 * in-page widget for the bar below UIkit's @m breakpoint (960px) via
 * hk-hidden@m / hk-visible@m — matchMedia keeps the mode live on resize.
 */
/**
 * The JS side of the floating-bar breakpoint. booking.css carries the SAME
 * number in its pre-hydration `[data-hr-sticky="on"]` rule (#919) — a test
 * pins the two together, change both or neither.
 */
export const MOBILE_MEDIA_QUERY = '(max-width: 959px)'

export function useIsMobile(query = MOBILE_MEDIA_QUERY): boolean {
  // Seed deterministically (false) so the client's first render matches the
  // server HTML; the effect below runs onChange() on mount to set the real
  // value one tick later. Reading matchMedia in the initializer would make a
  // <960px client hydrate a StickyBar/Dialog against the server's inline form
  // → hydration mismatch (#771).
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const mql = window.matchMedia(query)
    const onChange = () => setIsMobile(mql.matches)
    onChange()
    // Chrome doesn't reliably fire MediaQueryList change events for
    // programmatic window resizes — mirror them from resize (same-value
    // setState is a no-op, so this stays cheap).
    mql.addEventListener('change', onChange)
    window.addEventListener('resize', onChange)
    return () => {
      mql.removeEventListener('change', onChange)
      window.removeEventListener('resize', onChange)
    }
  }, [query])

  return isMobile
}
